var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail04Primery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16329 1.75576L14.182 5.0179C14.3593 5.13317 14.448 5.1908 14.5122 5.26768C14.5691 5.33574 14.6118 5.41445 14.6379 5.49922C14.6673 5.59498 14.6673 5.70073 14.6673 5.91224V10.8C14.6673 11.9201 14.6673 12.4802 14.4493 12.908C14.2576 13.2843 13.9516 13.5903 13.5753 13.7821C13.1475 14 12.5874 14 11.4673 14H4.53398C3.41388 14 2.85383 14 2.426 13.7821C2.04968 13.5903 1.74372 13.2843 1.55197 12.908C1.33398 12.4802 1.33398 11.9201 1.33398 10.8V5.91224C1.33398 5.70073 1.33398 5.59498 1.36343 5.49922C1.3895 5.41445 1.43222 5.33574 1.48908 5.26768C1.55332 5.1908 1.64199 5.13317 1.81933 5.0179L6.83801 1.75576M9.16329 1.75576C8.74246 1.48222 8.53205 1.34545 8.30534 1.29224C8.10494 1.2452 7.89637 1.2452 7.69597 1.29224C7.46925 1.34545 7.25884 1.48222 6.83801 1.75576M9.16329 1.75576L13.9794 4.88621C14.2086 5.03524 14.3233 5.10976 14.363 5.20426C14.3977 5.28684 14.3977 5.37991 14.363 5.4625C14.3233 5.557 14.2086 5.63151 13.9794 5.78055L9.16329 8.91099C8.74247 9.18453 8.53205 9.3213 8.30534 9.37452C8.10494 9.42155 7.89637 9.42155 7.69597 9.37452C7.46925 9.3213 7.25884 9.18453 6.83801 8.91099L2.02194 5.78055C1.79266 5.63151 1.67801 5.557 1.63831 5.4625C1.60361 5.37991 1.60361 5.28684 1.63831 5.20426C1.67801 5.10976 1.79266 5.03524 2.02194 4.88621L6.83801 1.75576",
    stroke: "#4C60E5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail04Primery);
export default __webpack_public_path__ + "static/media/mail-04-primery.91322fa5be880e2b6750523e32054787.svg";
export { ForwardRef as ReactComponent };